export default __webpack_public_path__ + "static/media/pof-acad-384x384.abc0fcec.png";